// @ts-ignore
import {ApiValidation} from '../../model/api/api-validation';
import {TableRecordResult} from '../../model/api/table-record-result';
import {CrystalclearBackUrl} from './crystalclear-back-url';
import {Trade} from "../../model/clearing/trade";
import {Order} from "../../model/clearing/order";
import {Clearing} from "../../model/clearing/clearing";
import {FieldResult} from "../../model/api/field-result";
import {GatewayConnection} from "../../model/hub/gateway-connection";

export class CrystalclearSupportBackUrl {
  //SYNC
  static readonly SYNC_SUPPORT_SYNC_ALL: CrystalclearBackUrl.UrlConf<ApiValidation<any>> = {
    url: '/api/support/sync',
    type: ApiValidation
  };
  static readonly SYNC_SUPPORT_SYNC_STATICS: CrystalclearBackUrl.UrlConf<ApiValidation<any>> = {
    url: '/api/support/sync-statics',
    type: ApiValidation
  };
  static readonly SYNC_SUPPORT_SYNC_PUBLISHER: CrystalclearBackUrl.UrlConf<ApiValidation<any>> = {
    url: '/api/support/sync-publisher',
    type: ApiValidation
  };
  static readonly SYNC_SUPPORT_SYNC_ALL_GW: CrystalclearBackUrl.UrlConf<ApiValidation<any>> = {
    url: '/api/support/sync-all-gw',
    type: ApiValidation
  };
  static readonly SYNC_SUPPORT_SYNC_SINGLE_GW: CrystalclearBackUrl.UrlConf<ApiValidation<any>> = {
    url: '/api/support/sync-single-gw',
    type: ApiValidation
  };
  static readonly SYNC_SUPPORT_CONNECTED_GWS: CrystalclearBackUrl.UrlConf<FieldResult<GatewayConnection>> = {
    url: '/api/support/connected-gws',
    type: FieldResult
  };

  //SUPPORT TRADE
  static readonly GET_SUPPORT_TRADE_LIST: CrystalclearBackUrl.UrlConf<TableRecordResult<Trade>> = {
    url: '/api/support/trade/list',
    type: TableRecordResult
  };

  static readonly SAVE_SUPPORT_TRADE: CrystalclearBackUrl.UrlConf<ApiValidation<Trade>> = {
    url: '/api/support/trade/save',
    type: ApiValidation
  };

  static readonly SAVE_BATCH_SUPPORT_TRADE: CrystalclearBackUrl.UrlConf<ApiValidation<Trade>> = {
    url: '/api/support/trade/save-batch',
    type: ApiValidation
  };

  static readonly DELETE_SUPPORT_TRADE: CrystalclearBackUrl.UrlConf<ApiValidation<any>> = {
    url: '/api/support/trade/delete',
    type: ApiValidation
  };

  //SUPPORT ORDER
  static readonly GET_SUPPORT_ORDER_LIST: CrystalclearBackUrl.UrlConf<TableRecordResult<Order>> = {
    url: '/api/support/order/list',
    type: TableRecordResult
  };

  static readonly SAVE_SUPPORT_ORDER: CrystalclearBackUrl.UrlConf<ApiValidation<Order>> = {
    url: '/api/support/order/save',
    type: ApiValidation
  };

  static readonly SAVE_BATCH_SUPPORT_ORDER: CrystalclearBackUrl.UrlConf<ApiValidation<Order>> = {
    url: '/api/support/order/save-batch',
    type: ApiValidation
  };

  static readonly DELETE_SUPPORT_ORDER: CrystalclearBackUrl.UrlConf<ApiValidation<any>> = {
    url: '/api/support/order/delete',
    type: ApiValidation
  };

  //SUPPORT CLEARING
  static readonly GET_SUPPORT_CLEARING_LIST: CrystalclearBackUrl.UrlConf<TableRecordResult<Clearing>> = {
    url: '/api/support/clearing/list',
    type: TableRecordResult
  };

  static readonly SAVE_SUPPORT_CLEARING: CrystalclearBackUrl.UrlConf<ApiValidation<Clearing>> = {
    url: '/api/support/clearing/save',
    type: ApiValidation
  };

  static readonly SAVE_BATCH_SUPPORT_CLEARING: CrystalclearBackUrl.UrlConf<ApiValidation<Clearing>> = {
    url: '/api/support/clearing/save-batch',
    type: ApiValidation
  };

  static readonly DELETE_SUPPORT_CLEARING: CrystalclearBackUrl.UrlConf<ApiValidation<any>> = {
    url: '/api/support/clearing/delete',
    type: ApiValidation
  };
}
